export const applicationNamespace = 'app'

export type LanguagePack = { [key: string]: string | LanguagePack }
export type Resources = {
  [key: string]: LanguagePack
}
